import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateClientCancellationReasonSaga } from "src/store/clientcancelreason/saga";
import { ClientCancellationReasonDetailDto } from "src/store/clientcancelreason/type";
import * as Yup from "yup";

const ClientCancellationReasonEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: ClientCancellationReasonDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("ClientCancellationReason.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Content: data.Content,
          Translates: data.Translates.map((x) => {
            return {
              LanguageId: x.LanguageId,
              Content: x.Content,
            };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            updateClientCancellationReasonSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Content: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Content: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Content",
            label: t("ClientCancellationReason.Content").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ClientCancellationReasonEditForm;
